import React from 'react'
import { ShopProduct } from '../../../Api'
import { Head3 } from '../../Typography/Text.styles'
import { ShopConInner, ShopConOuter } from './styles'
import { logBrazeEvent, logEvent } from '../../../Utils'
import { createShopUTM } from '../../../Routing'
import { Img } from '../../Image/Img'
import { fontSizes } from '../../consts'
type ProductItemParams = {
  product: ShopProduct
  size: 'normal' | 'small'
  medium: string
  campaign: string
}

export const ShopItem: React.FC<ProductItemParams> = ({
  product,
  size,
  medium,
  campaign,
}) => {
  let shopLink = createShopUTM({
    medium,
    campaign,
    slug: product.onlineStoreUrl,
    isFullLink: true,
  })

  const log = (name: string, params: any) => {
    logEvent(name, params)
    logBrazeEvent(name, params)
  }

  return (
    <ShopConOuter size={size}>
      <ShopConInner href={shopLink} size={size} aria-label={product.title}>
        <div
          className="inner"
          onClick={() =>
            log('shop_item_click', {
              item_name: product.title,
              item_id: product.id,
              item_price: product.price,
              item_category: product.productType,
              item_sku: product.variants[0].sku,
              medium,
              campaign,
            })
          }
        >
          <div className="imgCon">
            <Img src={product.featuredImage} alt={product.title} />
          </div>
          <Head3 justify="center" fontSize={fontSizes.small} sideMargins={2}>{product.title}</Head3>
          <p className="price">${product.price}</p>
        </div>
      </ShopConInner>
    </ShopConOuter>
  )
}
